import { render, staticRenderFns } from "./OrgMainContainer.vue?vue&type=template&id=200649d5&scoped=true"
import script from "./OrgMainContainer.vue?vue&type=script&lang=js"
export * from "./OrgMainContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200649d5",
  null
  
)

export default component.exports